export interface Tick {
  price: number
  volume?: number
  time?: number
}

export interface TickCandle {
  time: number
  open: number
  high: number
  low: number
  close: number
  volume: number
}

type TickListener = (tick: Tick) => void
type CandleListener = (candles: TickCandle[]) => void

class TickAPI {
  private tickListeners: TickListener[] = []
  private candleListeners: CandleListener[] = []

  pushTick(tick: Tick): void {
    const t: Tick = {
      ...tick,
      time: tick.time ?? Math.floor(Date.now() / 1000),
    };
    this.tickListeners.forEach((fn) => fn(t));
  }

  pushCandles(candles: TickCandle[]): void {
    if (candles.length === 0) return;
    this.candleListeners.forEach((fn) => fn(candles));
  }

  onTick(fn: TickListener): () => void {
    this.tickListeners.push(fn);
    return () => { this.tickListeners = this.tickListeners.filter((l) => l !== fn); };
  }

  onCandles(fn: CandleListener): () => void {
    this.candleListeners.push(fn);
    return () => { this.candleListeners = this.candleListeners.filter((l) => l !== fn); };
  }

  get listenerCount(): number {
    return this.tickListeners.length + this.candleListeners.length;
  }
}

export const tickApi = new TickAPI();

if (typeof window !== 'undefined') {
  (window as any).__ADESK_TICK_API__ = tickApi;
}
